<template>
  <div class="assistant-popover__rows">
    <div
        v-for="assistant in assistants"
        :key="assistant.id"
        class="assistant-popover__row assistant-popover__rows--available"
    >
      <Avatar size="small" :image="assistant.icon" shape="circle"/>
      <div class="assistant-popover__assistant-info">
        <div class="assistant-popover__assistant-external-info" :title="assistant.name">
          {{ assistant.name }}
        </div>
      </div>
      <AssistantRowButtons
          :mode="ASSISTANT_BUTTONS_MODE.AVAILABLE"
          :block-adding="blockAdding"
          :assistant-id="assistant.id"
          :assistant="assistant"
          @attach="(id) => $emit('attach', id)"
          @view="(assistant) => $emit('view', assistant)"
      />
    </div>
  </div>
</template>

<script setup>
import Avatar from "primevue/avatar";
import {computed} from "vue";
import {ASSISTANT_BUTTONS_MODE} from "@/constants";
import {useChatStore} from "@/modules/chat/stores/chatStore";
import AssistantRowButtons from "@/modules/chat/components/assisstant/Popover/AssistantRowButtons.vue";
import {useReferenceStore} from "@/modules/chat/stores/referenceStore";

defineProps({
  assistants: {
    type: Array,
    required: true
  }
});

const chatState = useChatStore();
const {assistants_limit: assistantsLimit} = useReferenceStore();
const blockAdding = computed(() => chatState.assistants.length >= assistantsLimit);
defineEmits(['attach', 'view']);
</script>
